<div
  *ngIf="templateTimelineItems || timelineItems"
  class="timeline-holder pt-5"
  [@listAnimation]="timelineItems.length"
  [@.disabled]="!stagger"
>
  <ng-container
    *ngIf="
      templateTimelineItems && templateTimelineItems.length > 0;
      else standard
    "
  >
    <ng-container
      *ngFor="let template of templateTimelineItems; let index = index"
    >
      <div>
        <ng-container *ngTemplateOutlet="template"></ng-container>
      </div>
    </ng-container>
  </ng-container>

  <ng-template #standard>
    <ng-container
      *ngFor="let item of timelineItems; let index = index; let last = last"
    >
      <canvas-timeline-item
        *ngIf="item.type === 'text'"
        [Last]="last"
        [Title]="item.content"
        [Subtitle]="item.title"
      ></canvas-timeline-item>
      <canvas-timeline-item
        *ngIf="item.type === 'img'"
        [Last]="last"
        [Subtitle]="item.title"
      >
        <img [src]="item.content" [alt]="item.title" />
      </canvas-timeline-item>
    </ng-container>
  </ng-template>
</div>
